import { useAuthorization } from "@sttedra_ui/framework";

import DataSourcesView from "../data-sources/DataSourcesView.vue";

export default [
  {
    path: "/admin/DataSources",
    name: "DataSources",
    component: DataSourcesView,
    meta: { title: "Fuentes de datos", requiresAuthentication: false },
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("layout", "admin");

      const { modelRef: authorizationModelRef } = useAuthorization();

      const userRol = authorizationModelRef.value.roles[0];

      if (userRol != "Admin") {
        next({ name: "Login" });
      }

      next();
    },
  },
];
